import { render, staticRenderFns } from "./LabourerTakeonCard.vue?vue&type=template&id=975ff580&scoped=true&"
import script from "./LabourerTakeonCard.vue?vue&type=script&lang=js&"
export * from "./LabourerTakeonCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975ff580",
  null
  
)

export default component.exports